import { useEffect } from 'react';
import { ThemeConfig } from '@/types/theme';
import { getThemeCSSVariables } from '@/services/theme.service';

/**
 * Hook per applicare le variabili CSS del tema al DOM.
 * Si occupa di aggiornare <html> e <body> ogni volta che cambia il tema.
 */
export function useApplyTheme(theme: ThemeConfig) {
  useEffect(() => {
    const root = document.documentElement;
    const cssVars = getThemeCSSVariables(theme);

    Object.entries(cssVars).forEach(([key, value]) => {
      root.style.setProperty(key, value);
    });

    document.body.style.backgroundColor = theme.backgroundColor || '';
    document.body.style.color = theme.textColor || '';
  }, [theme]);
}
